import React, { useRef, useState } from "react";
import ReactDOM from "react-dom";
import { ReactSVG } from "react-svg";

import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { textConvert } from "../../../components/language/dropdown/textconvert";

function CaddieSearch({
  search,
  setSearch,
  openSearch,
  setOpenSearch,
  setTriggerSearch,
  setPage,
  setHasMore,
  searchInput,
  setSearchInput,
}) {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  const handleProviceSelect = (province) => {
    setOpenSearch(false);
    setSearch({
      ...search,
      province: {
        state: true,
        value: province,
      },
    });
    setOpenSearch(false);
  };

  const handleOnTypeSearch = (e) => {
    const value = e.target.value;
    if (value.trim() === "") {
      setSearchInput(value);
      setTriggerSearch(false);
    } else {
      setSearchInput(value);
    }
  };

  const handleKeyDown = (e) => {
    setPage(0);
    setHasMore(true);
    const value = e.target.value;
    if (e.key === "Enter") {
      setOpenSearch(false);
      triggerSearch(value);
      setTriggerSearch(true);
    }
  };

  const handleSearch = () => {
    setPage(0);
    setHasMore(true);
    const value = inputRef.current.value; // ดึงค่าจาก input
    setOpenSearch(false);
    triggerSearch(value); // ส่งค่าจาก input ไปยัง triggerSearch
    setTriggerSearch(true);
  };

  const triggerSearch = (value) => {
    // console.log(value);
    setSearch({
      ...search,
      text: {
        state: true,
        value: value,
      },
    });

    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const handleNearMe = (nearMe) => {
    setOpenSearch(false);
    setSearch({
      ...search,
      nearMe: {
        state: true,
      },
    });
    setOpenSearch(false);
  };

  return (
    <>
      <Dropdown show={openSearch}>
        {/* <Dropdown.Toggle as="div">
          <div className="search-form-2 flex-grow-1">
            <i className="ti-search font-xss" onClick={handleSearch}></i>
            <input
              type="text"
              className="form-control text-grey-500 mb-0 bg-greylight theme-dark-bg border-0"
              placeholder={t(textConvert('search here'))}
              onChange={handleOnTypeSearch} // ค้นหาทันทีที่พิมพ์
              onKeyDown={handleKeyDown} // ค้นหาเมื่อกด Enter
              ref={inputRef}
              value={searchInput}
            />
          </div>
        </Dropdown.Toggle> */}
        <div className="input-group">
        <input
              type="text"
              className="form-control"
              placeholder={t(textConvert('search here'))}
              onChange={handleOnTypeSearch} // ค้นหาทันทีที่พิมพ์
              onKeyDown={handleKeyDown} // ค้นหาเมื่อกด Enter
              onFocus={() => setOpenSearch(true)}
              onBlur={() => setOpenSearch(false)}
              ref={inputRef}
              value={searchInput}
            />
          <div class="input-group-append">
            <button
              className="btn btn-light h-100"
              onClick={handleSearch}
            >
              <i className="bi bi-search"></i>
            </button>
          </div>
        </div>
        <Dropdown.Menu
          style={{
            maxWidth: "calc(100% - 16px)", // ปรับความกว้างให้เหมาะสม
            width: "auto", // ใช้ความกว้างอัตโนมัติตามเนื้อหา
            minWidth: "280px", // ตั้งค่าความกว้างขั้นต่ำ
          }}
        >
          <Dropdown.Item
            onClick={handleNearMe}
            style={{
              display: "flex",
            }}
            className="fw-600"
          >
            <ReactSVG
              src="assets/icon/golf-course/Course-Near Me.svg"
              style={{ width: "25px", marginRight: "8px" }}
            />
            <h4 className="fw-600 mt-1">Near Me</h4>
          </Dropdown.Item>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "default",
              userSelect: "none",
              padding: "0.25rem 1rem",
            }}
          >
            <ReactSVG
              src="assets/icon/golf-course/Course-Location Recommend.svg"
              style={{ width: "25px", marginRight: "8px" }}
            />
            <h4 className="fw-600 mt-2">Popular Location</h4>
          </div>
          <Dropdown.Item
            onClick={() => handleProviceSelect("Pathum Thani")}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <ReactSVG
              src="assets/icon/golf-course/Course-Location.svg"
              style={{ width: "25px", marginRight: "8px", marginLeft: "22px" }}
            />

            <h4 className="mt-2">Pathum Thani</h4>
          </Dropdown.Item>

          <Dropdown.Item
            onClick={() => handleProviceSelect("Chon Buri")}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <ReactSVG
              src="assets/icon/golf-course/Course-Location.svg"
              style={{ width: "25px", marginRight: "8px", marginLeft: "22px" }}
            />
            <h4 className="mt-2">Chon Buri</h4>
          </Dropdown.Item>

          <Dropdown.Item
            onClick={() => handleProviceSelect("Phuket")}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <ReactSVG
              src="assets/icon/golf-course/Course-Location.svg"
              style={{ width: "25px", marginRight: "8px", marginLeft: "22px" }}
            />
            <h4 className="mt-2">Phuket</h4>
          </Dropdown.Item>

          <Dropdown.Item
            onClick={() => handleProviceSelect("Chiang Mai")}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <ReactSVG
              src="assets/icon/golf-course/Course-Location.svg"
              style={{ width: "25px", marginRight: "8px", marginLeft: "22px" }}
            />
            <h4 className="mt-2">Chiang Mai</h4>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}

export default CaddieSearch;

function CustomDropdown({ children, ...props }) {
  return ReactDOM.createPortal(
    <Dropdown.Menu {...props}>{children}</Dropdown.Menu>,
    document.body
  );
}
